import { useQuery } from '@tanstack/react-query';
import * as Mappers from '../mappers';
import * as Queries from '../queries';
import * as Types from '../types';

interface IProps {
  id: string;
  enabled?: boolean;
}

const useSingle = ({ id, enabled = true }: IProps) => {
  const initialData = { item: Mappers.ResultDetails() } as Types.IQuery.Single;

  const { data = initialData, ...args } = useQuery<Types.IQuery.Single>({
    queryKey: ['result', 'single', id],
    queryFn: Queries.Single({ id })[1],
    enabled: !!id && enabled,
  });

  return { ...args, ...data };
};

export default useSingle;
